import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BlockView from "@/views/share/BlockView.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'MainDraftSegView',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!

  return (_openBlock(), _createBlock(BlockView, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_typography_title, { level: 5 }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("我的草稿", -1)
        ]))]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})